<template>
  <div id="app" :class="wrappingClass">
    <Header/>
    <PriceDropBanner v-if="showPriceDropBanner" data-qa="price-drop-banner" />
    <CommonBenefits v-else data-qa="common-benefits" />
    <div class="section">
      <div class="container">
        <div class="columns is-centered">
          <div class="column is-half-desktop is-half-tablet">
            <div
              class="por-notification--wrapper"
              v-if="message || warningMessage"
              data-qa="notification">
              <!-- Used for internal messages -->
              <b-message
                v-if="message"
                :type="`is-${type}`"
                data-qa="notification">
                  <template v-if="hasTitle"><strong>{{ $t(title) }}</strong><br><span v-if="message">{{ $t(message) }}</span></template>
                  <template v-else-if="hasPhoneNumber">{{ $t('common_accountSuspend_text', { phoneNumber }) }}</template>
                  <template v-else-if="isTranslated">{{ message }}</template>
                <template v-else><span v-html="$t(message,{ urlPrefix })"></span></template>
              </b-message>
              <!-- Used by external applications with query param -->
              <b-message
                v-if="warningMessage"
                type="is-warning"
                data-qa="notification">
                  <!-- String deliberately not translated, as it should be passed by external application already translated -->
                {{ warningMessage }}
              </b-message>
            </div>
            <router-view />
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { getUrlParameter } from '@/helpers/url'
import { isSuperdrugBrand, isAsdaBrand } from '@/helpers/env'
import { addHotjarMiddleWare } from '@/config/setup/segment.setup'
import CommonBenefits from '@/components/benefits/CommonBenefits.vue'
import PriceDropBanner from '@/components/banners/PriceDropBanner.vue'
import Header from 'components/header/Header.vue'
import Footer from 'components/footer/Footer.vue'

export default {
  name: 'App',
  metaInfo () {
    return {
      ...this.metaData
    }
  },
  components: {
    CommonBenefits,
    PriceDropBanner,
    Header,
    Footer
  },
  computed: {
    ...mapGetters({
      title: 'site/title',
      message: 'site/message',
      type: 'site/type',
      phoneNumber: 'site/phoneNumber',
      metaData: 'site/metaData',
      urlPrefix: 'site/urlPrefix',
      pseudoLocale: 'site/language'
    }),
    hasPhoneNumber () {
      return this.message.includes('{phoneNumber}') && this.phoneNumber
    },
    isTranslated () { // TODO: Cleanup, this is a temporary hack
      return this.message.includes('We have sent a code to reset your password to the following address:')
    },
    hasTitle () {
      return this.title && this.title !== ''
    },
    isSuperdrug () {
      return isSuperdrugBrand()
    },
    isAsda () {
      return isAsdaBrand()
    },
    isZavaUk () {
      return this.pseudoLocale === 'en_GB'
    },
    showPriceDropBanner () {
      return this.isZavaUk
    },
    wrappingClass () { // Only needed for the icon hack, remove when icons work with ui-packages and use the bulma-overrides class on App.vue
      if (this.isSuperdrug) {
        return 'sd bulma-overrides'
      } else if (this.isAsda) {
        return 'asda bulma-overrides'
      } else {
        return 'zava bulma-overrides'
      }
    }
  },
  data: function () {
    return {
      warningMessage: null
    }
  },
  methods: {
    clear () {
      this.$store.dispatch('site/clearMessage')
    }
  },
  mounted () {
    this.warningMessage = getUrlParameter('warning')
    addHotjarMiddleWare()
  }
}
</script>

<style lang="scss">
  $por-input-field--error-border: 1px solid $danger;
  $por--divider-border: 1px solid $n-300;

  .por-notification--wrapper {
    margin-bottom: 16px;
  }

  .por-input-field--error {
    border: $por-input-field--error-border !important;
  }

  .por-input-error-text {
    display: block;
    color: $danger;

    // Bulma values
    font-size: 0.875rem;
    margin-top: 0.25rem;
  }

  // WCAG 1.4.3 - The empty select's placeholder of rgba($grey, 0.7) does not meet the contrast requirement of 4.5:1 against white.
  // $s-low matches the placeholder colour for .input and .textarea and exceeds 4.5:1.
  span.select.is-empty select {
    color: $s-low;
  }

  .columns-no-margin {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .column-no-padding {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .por--divider {
    display: flex;
    flex-direction: row;
    font-size: 16px;
    font-weight: bold;
    line-height: 24px;

    &:before,
    &:after {
      content: "";
      flex: 1 1;
      border-bottom: $por--divider-border;
      margin: auto;
    }

    &:before {
      margin-right: 28px
    }

    &:after {
      margin-left: 28px
    }
  }
</style>
